import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { AuthService }  from './services/auth.service';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', title: 'XBC', component: DashboardComponent, pathMatch: 'full', canActivate: [AuthService] },
  { path: 'home', title: 'XBC', component: DashboardComponent, pathMatch: 'full', canActivate: [AuthService] },
  { path: 'authorization', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'backoffice', loadChildren: () => import('./backoffice/backoffice.module').then(m => m.BackofficeModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'rspsetup', loadChildren: () => import('./rspsetup/rspsetup.module').then(m => m.RspSetupModule) },
  { path: 'common', loadChildren: () => import('./common/xbc-common.module').then(m => m.XBCCommonModule) },
  { path: '**', title: 'XBC-Page Not Found', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
